exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spacer {\n  min-height: 3rem;\n}\n", ""]);

// exports
